export const HOMEPAGE = "https://gotrellis.com/";
